import React from 'react'
import RichTextEditor from 'react-rte';
import Button from '../basic/button'
import getUrl from "../../src/getUrl";

export default class Editor extends React.Component {
  state = {
    value: RichTextEditor.createEmptyValue()
  }

  onChange = (value) => {
    this.setState({value})
  }

  componentDidMount() {
    const {text} = this.props
    this.onChange(RichTextEditor.createValueFromString(text, 'html'))
  }

  render() {
    const {id, changeMode, reload} = this.props
    const {value} = this.state
    return (
      <div>
        <RichTextEditor
          ref='rtEditor'
          value={value}
          onChange={this.onChange}
          customControls={[
            // eslint-disable-next-line no-unused-vars
            (setValue, getValue, editorState) => {
              return (
                <div
                  onClick={() => {
                    let cd = new DataTransfer()
                    cd.setData('text/plain', '®')
                    this.refs.rtEditor.refs.editor._onPaste({
                      preventDefault: () => {
                      },
                      clipboardData: cd
                    })
                    setTimeout(() => {
                      this.refs.rtEditor._focus()
                    })
                  }}
                  style={{
                    marginLeft: 5,
                    display: 'inline-block',
                    cursor: 'pointer',
                    width: 29,
                    height: 29,
                    lineHeight: '29px',
                    border: '1px solid #999',
                    textAlign: 'center'
                  }}
                >
                  ®
                </div>
              );
            }
          ]}
        />
        <Button
          style={{marginTop: 10}}
          onClick={() => {
            fetch(getUrl(`/api/v1/dictionaries/fw/contents/${id}`), {
              headers: {
                'Content-Type': 'application/json; charset=utf-8'
              },
              method: 'PUT',
              credentials: 'include',
              body: JSON.stringify({val: value.toString('html'), code: id}),
            }).then(data => {
              return data.json()
            }).then(resp => {
              changeMode()
              reload()
            }).catch(err => {
              console.log(err)
            })
          }}
        >
          Сохранить
        </Button>
        <Button
          style={{marginTop: 10, marginLeft: 10}}
          onClick={() => {
            changeMode()
          }}
        >
          Отмена
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/text/Editor.js